"use client";

import { GET_REVIEWS_QUERY, ReviewData } from "@/gql/review";
import { logger } from "@/utils/logger";
import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

interface UseTestimonialsRefreshProps {
	limit?: number;
}

interface UseTestimonialsRefreshReturn {
	testimonials: ReviewData[];
	isLoading: boolean;
	error: string | null;
	refreshTestimonials: () => Promise<void>;
}

export const useTestimonialsRefresh = ({
	limit = 10,
}: UseTestimonialsRefreshProps = {}): UseTestimonialsRefreshReturn => {
	const [getReviews, { data, loading, error }] = useLazyQuery(GET_REVIEWS_QUERY, {
		fetchPolicy: "network-only", // Always fetch fresh data
	});

	if (error) {
		logger.error("Error fetching testimonials:", error);
	}

	const refreshTestimonials = useCallback(async () => {
		try {
			await getReviews({
				variables: {
					params: {
						get: {
							limit,
						},
					},
				},
			});
		} catch (error) {
			logger.error("Error refreshing testimonials:", error);
		}
	}, [getReviews, limit]);

	return {
		testimonials: data?.reviews?.get?.data || [],
		isLoading: loading,
		error: error?.message || null,
		refreshTestimonials,
	};
};
